var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.9 85",
    style: {
      enableBackground: "new 0 0 87.9 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#fff;stroke-width:1;}\n\t.st1{fill:#fff;}\n\t.st2{font-family:'Gotham-Medium';}\n\t.st3{font-size:12px;}\n\t.st4{fill:#fff;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "US-RI",
    className: "st0",
    d: "M64.7,26.3l-1.9,2.8l-3.7-2.6l-2.4-3.2l-2.6-1.5l-2.4-0.2l4.2,7.4l-2.6,7l3.4,15.5l-3.6,7.7 l-15.8,8.4l-5.2,0.9l-0.6-5.1l1.2-2.5l-1.2-5.4L30.8,52L29,46.2l-2-6.7l-2.2-7.2l-1.9-6.4l-1.4-4.6l-1.9-6.4l-1.4-4.5L23.3,9l7-1.9 l6.8-1.8l4.2-1.1l5.1-1.4l1.4,3.8l2.1,5.8l3.1,0.2l1.3,4.8l0.9,3.2l3.1,1.3l3.1,1.4L64.7,26.3z M69.8,44.6l-2.7,3.2l-3.9,0.6l1-3.6 L63.5,40l0.3-5.5l0.6-1.8l1.8-1.9L69.8,44.6z M61.4,47.4l-1.5,2.1L58,45.5l-0.1-5.1l1.3-0.4l1.4,2.3L61.4,47.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    transform: "translate(7185.533 -3996.003)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRi);
export default __webpack_public_path__ + "static/media/RI.765e41a7d891186b3bb2c1caf27e75c0.svg";
export { ForwardRef as ReactComponent };